import {FreeSeriesStaticLandingPageVo} from '../../common/shared/api/karina/vo/page/FreeSeriesStaticLandingPageVo.interface';
import {
  StaticLandingFreeSeriesParamInput,
  StaticLandingFreeSeriesSectionParam,
} from '../generated/types';
import {createSortOption} from './SortOption';

export function createStaticLandingFreeSeriesSectionParam(
  FreeSeriesStaticLandingPageVo: FreeSeriesStaticLandingPageVo,
  input: StaticLandingFreeSeriesParamInput
): StaticLandingFreeSeriesSectionParam {
  return {
    categoryUid: input.categoryUid,
    tab: FreeSeriesStaticLandingPageVo.selected_tab_opt
      ? createSortOption({
          filterOptionVo: FreeSeriesStaticLandingPageVo.selected_tab_opt,
        })
      : undefined,
    page: input.page,
    screenUid: input.screenUid,
  };
}
